import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, ArrowRight, FileCheck2 } from "lucide-react";
import PdfPreview from "./PdfPreview";
import { Reveal } from "./Reveal";

export default function TransformVisualizer() {
  return (
    <section className="relative px-5 py-20 sm:py-28 bg-white border-y border-slate-200/70 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider bg-slate-100 text-slate-600 mb-4">A mágica do Basiq</div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Da mensagem ao PDF profissional</h2>
          <p className="mt-4 text-slate-600 text-base sm:text-lg">Escreva como você fala. A IA entende, organiza os itens, calcula os totais e monta o documento com a sua marca.</p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-6 items-center">
          {/* message side */}
          <Reveal delay={0.05}>
            <div className="mx-auto max-w-sm">
              <div className="flex items-center gap-2 mb-3 text-[12px] font-medium text-slate-400">
                <MessageCircle size={15} className="text-[#25D366]" /> Você escreve
              </div>
              <div className="space-y-2.5">
                <div className="ml-auto max-w-[85%] bg-slate-900 text-white rounded-2xl rounded-tr-md px-4 py-3 text-[14px] leading-relaxed shadow-sm">
                  Aê, faz pra mim: 10 mesas de madeira e 20 cadeiras pro cliente Marcos, entrega semana que vem.
                </div>
                <div className="ml-auto max-w-[70%] bg-slate-900 text-white rounded-2xl rounded-tr-md px-4 py-3 text-[14px] leading-relaxed shadow-sm">
                  mesa 450 cada, cadeira 120. 30% de entrada.
                </div>
                <div className="flex items-center gap-1.5 text-[12px] text-slate-400 mt-1">
                  <span className="w-1.5 h-1.5 rounded-full google-gradient" /> Basiq entendeu e está montando…
                </div>
              </div>
            </div>
          </Reveal>

          {/* arrow */}
          <Reveal delay={0.15} className="hidden lg:block">
            <div className="flex flex-col items-center gap-2">
              <div className="relative w-28 h-1 rounded-full overflow-hidden bg-slate-100">
                <div className="absolute inset-0 google-progress" />
              </div>
              <div className="grid place-items-center w-11 h-11 rounded-full bg-slate-900 text-white shadow-lg">
                <ArrowRight size={18} />
              </div>
              <span className="text-[11px] font-medium text-slate-400">~11s</span>
            </div>
          </Reveal>

          {/* pdf side */}
          <Reveal delay={0.25}>
            <div className="mx-auto max-w-[320px]">
              <div className="flex items-center gap-2 mb-3 text-[12px] font-medium text-slate-400 justify-end">
                Você recebe <FileCheck2 size={15} className="text-emerald-600" />
              </div>
              <motion.div initial={{ scale: 0.92, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}>
                <PdfPreview
                  brand="Marcenaria Real"
                  title="Móveis sob medida"
                  client="Marcos Aurélio"
                  accent="#b45309"
                  items={[{ d: "Mesa de madeira maciça", q: 10, v: 450 }, { d: "Cadeira estofada", q: 20, v: 120 }, { d: "Entrada (30%)", q: 1, v: 0 }]}
                />
              </motion.div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
